import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Search, Leaf } from 'lucide-react';
import { useStore } from '../../store/useStore';
import { SignOutButton } from './SignOutButton';
import { NotificationsDropdown } from '../notifications/NotificationsDropdown';
import { motion } from 'framer-motion';

export const Header: React.FC = () => {
  const { currentUser, setSearchQuery } = useStore();
  const location = useLocation();
  const isCEO = currentUser?.role === 'CEO';

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const getSearchPlaceholder = () => {
    if (location.pathname.includes('/tasks')) {
      return "Search tasks...";
    }
    return "Search communications and tasks...";
  };

  return (
    <header className="bg-white border-b border-gray-200 fixed w-full top-0 z-50">
      <div className="max-w-full px-4 mx-auto">
        <div className="flex justify-between items-center h-16">
          <Link to="/">
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              className="flex items-center space-x-2"
            >
              <Leaf className="w-6 h-6 text-emerald-500" />
              <h1 className="text-xl font-bold bg-gradient-to-r from-emerald-500 to-emerald-700 bg-clip-text text-transparent">
                SF Naturals
              </h1>
            </motion.div>
          </Link>
          
          <div className="flex-1 max-w-2xl mx-8">
            <div className="relative">
              <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
              <input
                type="text"
                placeholder={getSearchPlaceholder()}
                className="w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                onChange={handleSearch}
              />
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <NotificationsDropdown />
            <SignOutButton />
            
            <div className="flex items-center space-x-3 px-3 py-1.5 bg-gray-50 rounded-full">
              <img
                className="h-8 w-8 rounded-full ring-2 ring-emerald-500 ring-offset-2"
                src={currentUser?.avatar}
                alt={currentUser?.name}
              />
              <div className="text-sm">
                <p className="font-medium text-gray-700">{currentUser?.name}</p>
                <p className="text-emerald-600 text-xs">{currentUser?.role}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};